export const PLUGIN_ID = 'telegram-bot';
